module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ldvyS"))).then(() => parcelRequire('d0iPb'));